export default __webpack_public_path__ + "static/media/inbar-twizzer.be4b66e6.png";